module.exports = __webpack_public_path__ + "static/img/Fertimo_Page.af5a6be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Fertimo/Fertimo_Page.gif
// module id = U2n8
// module chunks = 1